import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Paper } from '@mui/material'
import { Container, Col, Row } from 'react-bootstrap'
import { IoAddCircleOutline } from 'react-icons/io5'

import useFetchData from 'Shared/Hooks/useFetchData'
import DataTable from 'Shared/Components/DataTable'
import { apiUrl } from 'Shared/utils'
import TypeForm from './Forms/TypeForm'
import PopupModal from 'Shared/Components/PopupModal'

const AssetTypes = () => {
  const { role, projectInfo, setPageLoading } = useOutletContext()

  const { t } = useTranslation()
  const { send } = useFetchData()
  const navigate = useNavigate()
  const {  } = useOutletContext()

  const [equipmentTypes, setEquipmentTypes] = useState([])
  const [isformOpen, setFormOpen] = useState(false)
  const tableRef = useRef()

  const getEquipments = async () => {
    const body = await send({
      method: "GET",
      url: `${apiUrl}/assets_tracking/types`,
      returnType: "json"
    })

    body && setEquipmentTypes(body)
  }

  const loadData = async () => {
    tableRef.current.setTableLoading(true)

    await getEquipments(false)

    tableRef.current.setTableLoading(false)
  }

  useEffect(() => {
    const init = async () => {
      await Promise.all([
        getEquipments()
      ])

      setPageLoading(false)
    }

    init()
  }, [])

  return (<>
    <Container fluid className="mainContainer" style={{ backgroundColor: "white", borderRadius: "15px" }}>
      <Row style={{ height: "100%" }}>
        <Col xs={12} style={{ height: "100%", overflow: "auto", padding: "10px" }}>
          <Paper elevation={0} sx={{ height: "100%", display: "flex", flexFlow: "column" }}>
            <DataTable
              data={equipmentTypes} count={null} ref={tableRef}
              onRowClick={(["pm", "so", "admin"].includes(role) && projectInfo["info"]["assets_tracking"]["supplier"] === "") && function(e, row) { navigate(`./${row["type_id"]}`) }}
              columns={{
                "type_name": { "label": t("assetsTracking_equipmentType"), "sorting": false, "nowrap": true },
                "description": { "label": t("assetsTracking_equipmentDescription"), "sorting": false, "nowrap": true },
              }}
              appActions={() => { return [
                ((["pm", "admin"].includes(role) && projectInfo["info"]["assets_tracking"]["supplier"] === "")) &&
                {icon: <IoAddCircleOutline size={20}/>, text: t("general_add"), onClick: function() { setFormOpen(true) }}
              ]}}
            />
          </Paper>
        </Col>
      </Row>
    </Container> 

    <PopupModal isOpen={isformOpen} close toggle={() => setFormOpen(false)} width="80%" height="80%">
      <TypeForm mode="create" initialState={{}} reload={loadData}/>
    </PopupModal>
  </>)
}

export default AssetTypes